import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { UnivPrefsService } from './univ-prefs.service';
import { CalcConfigService } from './calc-config.service';
import { TrafficService } from './traffic.service';
import { LoggingService } from './logging.service';

@Injectable({
    providedIn: 'root'
})
export class LoadingGuard {
    constructor(
        private auth: AuthService,
        private ups: UnivPrefsService,
        private cc: CalcConfigService,
        private ts: TrafficService,
        private logging: LoggingService
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        // Extract schoolId from the parent route
        const schoolId = next.parent?.paramMap.get('schoolId') ?? '';
        const nextPathName = next.routeConfig?.path || '';
        const rawPath = state.url.split(/[?#]/)[0];
        const escapedSchoolId = schoolId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const logPath = schoolId
            ? rawPath.replace(new RegExp(`^/${escapedSchoolId}(?:/)?`), '')
            : rawPath.replace(/^\//, '');

        return this.auth.user.pipe(
            take(1),
            map(user => {
                if (user) {
                    this.logging.logUser(user, schoolId, logPath);
                }

                this.ups.loadPreferences(schoolId);

                switch (nextPathName) {
                    case 'questions':
                    case 'costs':
                    case 'packaging':
                    case 'populations':
                    case 'tables':
                    case 'formulas':
                    case 'inspector':
                    case 'sessions':
                    case 'superadmin':
                    case 'questions-admin':
                        this.cc.loadSchool(schoolId);
                        break;
                    case 'branding':
                    case 'onboarding':
                    case 'content':
                    case 'schools':
                    case 'api-errors':
                    case 'analytics':
                        break;
                    case 'dashboard':
                    case 'traffic':
                        this.ts.loadTraffic(schoolId);
                        break;
                    default:
                        console.log('path: ' + nextPathName + ' not found! Not loading anything');
                }

                return true;
            })
        );
    }
}
